import { Router } from '@angular/router';

declare function doPOST(url: string, data: any): Promise<any>;

export class HelpMeHost {
  static _endpointURL: string = 'http://localhost:8082/';

  _STATUS_NONE: number = 0;
  _STATUS_WAITING: number = 1;
  _STATUS_JOINED: number = 2;
  _STATUS_INPROGRESS: number = 3;
  _STATUS_ENDED: number = 3;

  private static sessionId: string | undefined = undefined;
  private _supportUserId: string = '';
  private _guestId: string = '';
  private _status: number = this._STATUS_NONE;

  private router: Router | undefined = undefined;

  private _broadcastEventsIntervalId = 0;
  private broadcastPositionInProgress: boolean = false;

  private horizontalPositionMultiplier = 1;
  private verticalPositionMultiplier = 1;

  eventQueue: any = {
    events: ([] = new Array()),
  };

  get sessionId() {
    return HelpMeHost.sessionId;
  }

  // Factory/singleton!!!
  // Setup requires some async processes, and that's not possible for a constructor.
  // Also, we want to ensure that only one host can exist at a time.
  constructor(data: any) {
    HelpMeHost.sessionId = data.sessionId;
    this._supportUserId = data.supportUserId;
    this._guestId = data.guestId;

    if (data.status) {
      this._status = data.status;
    }
  }

  static async createSession(
    supportUserId: string,
    guestId: string,
  ): Promise<HelpMeHost | void> {
    if (HelpMeHost.sessionId != undefined) {
      throw 'There is already an active host.';
    }

    let session: HelpMeHost | undefined = undefined;
    HelpMeHost.sessionId = await this._createSessionAPI(
      supportUserId,
      guestId,
    );

    if (HelpMeHost.sessionId != '') {
      session = new HelpMeHost({
        sessionId: HelpMeHost.sessionId,
        supportUserId: supportUserId,
        guestId: guestId,
      });

      return session;
    } else {
      throw 'error initializing HelpMe! session';
    }
  }

  public startSession(router: Router): void {
    console.log('Started session between Swipesum and ' + this._guestId);
    this.router = router;
  }

  public async isJoined() {
    if (HelpMeHost.sessionId == undefined) {
      throw 'There is no active session.';
    }

    let json = await HelpMeHost._isSessionJoinedAPI(HelpMeHost.sessionId);

    if (json.isJoined) {
      console.log('Host detected client joined');

      let clientWidth = json.clientScreenWidth;
      let clientHeight = json.clientScreenHeight;
      console.log(
        'Detected client resolution: ' + clientWidth + ' x ' + clientHeight,
      );

      let hostWidth = window.screen.availHeight;
      let hostHeight = window.screen.availWidth;
      console.log('Host resolution: ' + hostWidth + ' x ' + hostHeight);

      this.horizontalPositionMultiplier = clientWidth / hostWidth;
      this.verticalPositionMultiplier = clientHeight / hostHeight;
      console.log(
        'Calcuated aspect ratio: ' +
          this.horizontalPositionMultiplier +
          ' x ' +
          this.verticalPositionMultiplier,
      );

      this._status = this._STATUS_JOINED;

      console.log('Navigating to client location: ' + json.clientURL);
      this.router?.navigateByUrl(json.clientURL);

      var that = this;

      window.addEventListener('mousemove', function (e) {
        that._detectCursorAndQueue(that, e);
      });

      if (this._broadcastEventsIntervalId == 0) {
        var that = this;
        this._broadcastEventsIntervalId = window.setInterval(function () {
          that._broadcastEventQueueAPI();
        }, 500);
      }

      console.log('Host is now broadcasting UI events');
    }

    return this._status == this._STATUS_JOINED;
  }

  async endSession() {
    this._status = this._STATUS_ENDED;

    if (this.sessionId && (await this._endSessionAPI(this.sessionId))) {
      HelpMeHost.sessionId = undefined;
    } else {
      throw 'Server error while ending session';
    }
  }

  _detectCursorAndQueue(context: any, event: any) {
    // The little extra adjustments at the end can be solved by perfectly trimming the space around the image
    const x = event.pageX;
    const y = event.pageY;

    context.lastHostPosition = {
      x: Math.round(event.pageX * this.horizontalPositionMultiplier),
      y: Math.round(event.pageY * this.verticalPositionMultiplier),
    };
    context.eventQueue.events.push({
      eventType: 'position',
      position: context.lastHostPosition,
    });

    return false;
  }

  private static async _createSessionAPI(
    supportUserId: string,
    guestId: string,
  ): Promise<string> {
    let data = {
      supportId: supportUserId,
      clientId: guestId,
    };

    let response = await doPOST(
      HelpMeHost._endpointURL + 'createSession',
      data,
    );

    if (response.sessionId) {
      return response.sessionId;
    } else {
      throw 'error establishing a new HelpMe! session';
    }
  }

  private static async _isSessionJoinedAPI(sessionId: string): Promise<any> {
    let data = {
      sessionId: sessionId,
    };

    let json = await doPOST(HelpMeHost._endpointURL + 'isSessionJoined', data);

    return json;
  }

  private async _broadcastEventQueueAPI() {
    if (
      !this.broadcastPositionInProgress &&
      this.eventQueue.events.length > 0
    ) {
      this.broadcastPositionInProgress = true;

      let data = this.eventQueue;

      doPOST(HelpMeHost._endpointURL + 'sendUIEventQueue', data).then(
        (response) => {
          this.eventQueue = {
            events: [],
          };

          this.broadcastPositionInProgress = false;
        },
      );
    }
  }

  private async _endSessionAPI(sessionId: string): Promise<boolean> {
    let data = {
      sessionId: sessionId,
    };

    let response = await doPOST(HelpMeHost._endpointURL + 'endSession', data);

    return response.sessionEnded;
  }
}
